import script from "./otherForm.vue?vue&type=script&setup=true&lang=js"
export * from "./otherForm.vue?vue&type=script&setup=true&lang=js"

import "./otherForm.vue?vue&type=style&index=0&id=29e80ad8&lang=scss"

const __exports__ = script;

export default __exports__